import {
    Box, Text, Progress, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Button, useClipboard, VStack, Flex
} from '@chakra-ui/react';
import { FaCopy, FaClipboardCheck } from 'react-icons/fa';
import ScrollToTop from "../components/ScrollToTop";
import { useState } from "react";

const CopiarTexto = ({ assunto, conteudo }) => {
    const { hasCopied, onCopy } = useClipboard(conteudo);

    return (
        <Box p={4} borderWidth="1px" borderRadius="md">
            <Text mb={2} fontWeight="bold">{assunto}</Text>
            <Text mb={2}>{conteudo}</Text>
            <Button
                color={hasCopied ? "white" : "orange"}
                bg={hasCopied ? "orange" : "white"}
                size="sm" leftIcon={hasCopied ? <FaClipboardCheck /> : <FaCopy />} onClick={onCopy} colorScheme="orange">
                {hasCopied ? "Copiado!" : "Copiar"}
            </Button>
        </Box>
    );
};

const Ficheiro = ({ titulo, conteudos }) => {
    return (
        <AccordionItem border="1px solid #E2E8F0" borderRadius="md" my={2}>
            <h2>
                <AccordionButton _expanded={{ bg: "orange.100" }}>
                    <Box flex="1" textAlign="left" fontWeight="bold">
                        {titulo}
                    </Box>
                    <AccordionIcon />
                </AccordionButton>
            </h2>
            <AccordionPanel pb={4} height="auto" overflowY="auto" align="start">
                <VStack align="stretch" spacing={4}>
                    {conteudos.map((item, index) => (
                        <CopiarTexto key={index} assunto={item.assunto} conteudo={item.conteudo} />
                    ))}
                </VStack>
            </AccordionPanel>
        </AccordionItem>
    );
};

const Guias = () => {
    const [loading, setLoading] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);

    const coteudoRemoverImpactoReclamacao = [
        {
            "assunto": "Falta de Estoque",
            "conteudo": "A reclamação afeta injustamente nossa reputação! O motivo alegado foi 'falta de estoque', mas isso não é verdade. Havia disponibilidade do produto. Pelo chat, explicamos ao cliente que a peça não era compatível com o chassi dele e sugerimos o cancelamento para evitar devolução ou danos ao veículo. Solicito remoção do impacto em minha reputação."
        },
        {
            "assunto": "Item Errado",
            "conteudo": "A reclamação afeta injustamente nossa reputação! O comprador alegou que a cor, tamanho ou lado estavam errados, mas isso é falso. Enviamos exatamente o produto conforme anunciado, sem qualquer divergência. O erro pode ter sido um equívoco do cliente ao interpretar o pedido. A queixa não procede e prejudica nossa credibilidade sem motivo."
        }
    ];

    const coteudoImpactoAtrasos = [
        {
            "assunto": "Passo 1",
            "conteudo": "Preciso de ajuda para remover os impactos causados por atrasos registrados na minha conta, por gentileza. Enfrentamos um imprevisto grave, ficamos sem energia por dias consecutivos, o que impossibilitou a bipagem dos itens programados. Essa situação inesperada gerou diversos atrasos e está afetando significativamente nossa avaliação, colocando em risco nosso status de Mercado Líder."
        },
        {
            "assunto": "Passo 2",
            "conteudo": "Gostaria de destacar que a situação já foi completamente resolvida, e estamos implementando melhorias contínuas para garantir um atendimento cada vez melhor aos nossos clientes. Peço, com muita gentileza, o suporte de vocês para reverter esses impactos, garantindo que nossa reputação reflita o esforço e a dedicação que temos ao longo do tempo."
        },
        {
            "assunto": "Passo 3",
            "conteudo": "Poderia me ajudar por favor ? Os ids das vendas são os seguintes:"
        }
    ];

    const conteudoSolicitarCancelamento = [
        {
            "assunto": "Passo 1",
            "conteudo": "Gostaria de solicitar o cancelamento desta venda. Trata-se de uma peça muito específica para um tipo de caminhão, que só podemos enviar mediante a confirmação do modelo e do chassi do veículo do comprador. No entanto, já se passaram mais de 48 horas sem qualquer resposta do comprador pelo chat do Mercado Livre."
        },
        {
            "assunto": "Passo 2",
            "conteudo": "Não podemos enviar peças sem essa confirmação, pois são específicas e há risco de devoluções ou até de danos ao veículo caso a peça seja incompatível. Por isso, solicito o cancelamento da venda sem impacto em minha reputação. Agradeço a compreensão."
        },
        {
            "assunto": "Passo 3",
            "conteudo": "Os ids das vendas são os seguintes:"
        }
    ];

    const coteudoMediacaoDevolucao = [
        {
            "assunto": "Item Avariado",
            "conteudo": "O produto não chegou nas mesmas condições em que foi enviado. Ele apresentou danos significativos, incluindo marcas de tentativa de uso, amassados e arranhões por toda a peça, evidenciando uma instalação inadequada e falta de cuidados. Partes quebradas. Diante desse estado, não conseguimos revendê-lo. Quero reembolso."
        }
    ];

    const conteudoConfirmacaoCompatibilidade = [
        {
            "assunto": "Confirmação de Compatibilidade",
            "conteudo": "Olá! Para garantir uma boa experiência e evitar possíveis problemas de devolução, por favor, envie o chassi, modelo e ano do veículo. Isso nos ajuda a confirmar a compatibilidade antes do envio e evitar a tentativa de aplicar uma peça errada, o que pode danificar o veículo. Agradecemos pela compreensão!"
        },
        {
            "assunto": "Confirmação de Compatibilidade",
            "conteudo": "Olá! Por favor, envie todos os dados completos do veículo: chassi, modelo e ano. Agradecemos sua compreensão e aguardamos seu retorno."
        }
    ];

    const conteudoSolicitarCancelamentoComprador = [
        {
            "assunto": "1",
            "conteudo": "Olá, amigo! Após analisar as informações que você forneceu, infelizmente, a peça não é compatível com o seu veículo. Peço, por gentileza, que cancele a compra para evitar o processo de devolução ou possíveis danos ao veículo ao tentar instalar uma peça inadequada. Qualquer dúvida, estou à disposição."
        },
        {
            "assunto": "2",
            "conteudo": "Entendo, meu amigo. Pedimos desculpas pelo transtorno. Por política da loja, não enviamos peças incompatíveis devido ao risco de devoluções e danos ao veículo, o que é prejudicial tanto para você quanto para nós. Por favor, cancele a compra marcando 'arrependimento' para receber o reembolso total o mais rápido possível. Agradecemos sua compreensão."
        },
        {
            "assunto": "3.1",
            "conteudo": "Entendo, meu amigo. Pedimos desculpas pelo transtorno. Por política da loja, não enviamos peças incompatíveis devido ao risco de devoluções e possíveis danos ao veículo, o que é prejudicial tanto para você quanto para nós. Por favor, informe o chassi, ano e modelo do veículo para que possamos verificar a compatibilidade e prosseguir com o envio, caso esteja tudo correto."
        },
        {
            "assunto": "3.2",
            "conteudo": "Se preferir, você pode cancelar a compra selecionando a opção 'arrependimento' para receber o reembolso total o mais rápido possível. Agradecemos sua compreensão e aguardamos seu retorno."
        },
        {
            "assunto": "4",
            "conteudo": "Pedimos desculpas pelo transtorno, mas não poderemos prosseguir com o envio. Por política da loja, não enviamos peças incompatíveis devido ao risco de devoluções e possíveis danos ao veículo, o que é prejudicial tanto para você quanto para nós. Por gentileza, cancele a compra selecionando a opção 'arrependimento' para receber o reembolso total o mais rápido possível. Agradecemos sua compreensão."
        },

    ];

    const conteudoMensagensReclamacao = [
        {
            "assunto": "Confusão de quantidade de unidades do anúncio",
            "conteudo": "Boa tarde! Pedimos desculpas pela confusão. Gostaríamos de esclarecer que o produto anunciado corresponde a apenas uma unidade, conforme especificado na descrição do anúncio. Não se trata de um kit ou conjunto. No entanto, para garantir sua satisfação, faremos o reembolso de { }% do valor pago. Caso tenha alguma dúvida, estamos à disposição."
        },
        {
            "assunto": "Reclamação sem motivo",
            "conteudo": "Boa tarde, amigo. Não entendemos o motivo da sua reclamação, pois temos a peça disponível em estoque. Como você optou por não prosseguir com a compra, iniciaremos o processo de reembolso. Estamos à disposição para qualquer dúvida."
        },
        {
            "assunto": "Reclamação com devolução",
            "conteudo": "Boa noite, amigo! Tudo bem? Pedimos desculpas pelo transtorno. Estamos iniciando o processo de devolução para você e estamos à disposição para esclarecer qualquer dúvida. Agradecemos pela paciência e, mais uma vez, nos desculpamos por qualquer inconveniente que possa ter ocorrido."
        },
    ];

    return (
        <>
            <ScrollToTop />
            <Box ml={{ base: "0", md: "8" }} textAlign="center" height={"100%"} py={10} bg="white" minH="100vh">
                <Box textAlign="center" ml={4} mb={0} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        GUIAS
                    </Text>
                </Box>
                <Box mx={{ base: 1, md: 12, lg: 18 }} mt={6} boxShadow='md' borderRadius="lg" px={0} mb={{ base: "2", md: "8", lg: "10" }} pb={12}>
                    {loadingLinear && <Progress mb={4} size='xs' isIndeterminate colorScheme="orange" />}
                    <Accordion allowToggle mx={2}>
                        <Ficheiro titulo="Remover Impacto de Reclamações" conteudos={coteudoRemoverImpactoReclamacao} />
                        <Ficheiro titulo="Remover Impacto de Atrasos" conteudos={coteudoImpactoAtrasos} />
                        <Ficheiro titulo="Solicitar Cancelamento de Vendas" conteudos={conteudoSolicitarCancelamento} />
                        <Ficheiro titulo="Mediação para Devoluções Avariadas" conteudos={coteudoMediacaoDevolucao} />
                        <Ficheiro titulo="Solicitar Confirmação de Compatibilidade para o Cliente" conteudos={conteudoConfirmacaoCompatibilidade} />
                        <Ficheiro titulo="Solicitar Cancelamento da Venda para o Cliente" conteudos={conteudoSolicitarCancelamentoComprador} />

                        <Ficheiro titulo="Respostas Reclamações para Clientes" conteudos={conteudoMensagensReclamacao} />
                    </Accordion>
                </Box>
            </Box>
        </>
    );
};

export default Guias;
